import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Card, CardBody, CardFooter } from 'reactstrap';
import Loader from "../../../components/display/Loader";
import ReduxModalWrapper from "../../../components/display/Modals/ReduxModalWrapper";
import Pill from "../../../components/display/Pill";
import ScoreIndicator from "../../../components/display/ScoreIndicator";
import { displayModal } from "../../../store/actions/display";
import PolyUtil from "../../../util/PolyUtil";
import OwnerApplicationView from './OwnerApplicationView';


class ApplicantCard extends Component {
    showApplicationModal = () => {
        this.props._displayModal({
            id: 'owner_application_view_modal_' + this.props.roommate.id,
            header: "Application for " + this.props.roommate.get_first_name + ' ' + this.props.roommate.get_last_name,
            body: (<OwnerApplicationView propId={this.props.propId} roommate={this.props.roommate}/>),
        });
    };

    content = () => {
        const {roommate} = this.props;

        var rental_length = 0;
        for (let rental of roommate.application.rental_history_rentals) {
            rental_length += Math.round(moment(rental.lease_end).diff(moment(rental.lease_start), "days") / 365);
        }
        const incidents = roommate.incident_count;
        const credit = roommate.credit_score;
        const references = roommate.aggregate_reference_sentiment;

        const rentalColor = rental_length >= 4 ? 'success'
            : rental_length >= 2 ? 'warning'
                : 'danger';
        const rentalText = (
            <span>
                {"Rental Experience: "}
                <strong>
                    {
                        rental_length === 1 ? "1 Year"
                            : rental_length + " Years"
                    }
                </strong>
            </span>
        );

        const referenceColor = (references[1] === 'Superb' || references[1] === 'Positive') ? 'success'
            : (references[1] === 'Neutral') ? 'warning'
                : (references[1] === 'Negative' || references[1] === 'Horrid') ? 'danger'
                    : 'info';

        const referenceText = (
            <span>
                {"References: "}
                <strong>
                    {references[1]}
                </strong>
            </span>
        );

        const incidentsColor = (incidents > 3) ? 'danger' : (incidents > 0) ? 'warning' : 'success';
        const incidentsText = (
            <span>
                {'Police Incidents: '}
                <strong>
                    {incidents}
                </strong>
            </span>
        );

        const creditColor = (credit.last_checked && moment().diff(moment(credit.last_checked), 'days') > 30) ? 'warning'
            : (!credit.score) ? 'info'
                : (credit.score > 700) ? 'success'
                    : (credit.score > 600) ? 'warning'
                        : 'danger';

        const creditText = (
            <span>
                {'Credit Score: '}
                <strong>
                    {
                        moment().diff(moment(credit.last_checked), 'days') > 30 ? 'Expired'
                            : credit.score || 'Unavailable'
                    }
                </strong>
            </span>
        );

        return (
            <Card>
                <CardBody>
                    <div className="justify-content-center mw-100" style={{marginBottom: '-1rem'}}>
                        <ScoreIndicator style={{marginBottom: '0.75rem'}} value={roommate.rentability_score} size={60}/>
                        <p className="text-center"><strong>{roommate.get_first_name + " " + roommate.get_last_name}</strong><br />{roommate.is_coordinator && "Group Coordinator"}</p>
                    </div>
                    <hr/>

                    <Pill color={rentalColor}>
                        {rentalText}
                    </Pill>

                    <Pill color={referenceColor}>
                        {referenceText}
                    </Pill>

                    <Pill color={incidentsColor}>
                        {incidentsText}
                    </Pill>

                    <Pill color={creditColor}>
                        {creditText}
                    </Pill>

                    <hr/>
                    <p>
                        <strong>Email: </strong>{roommate.application.email}<br />
                        <strong>Phone: </strong>{PolyUtil.formatPhone(roommate.application.phone)}
                    </p>
                </CardBody>

                <CardFooter style={{marginTop: '-1rem'}}>
                    <Button color="primary" onClick={this.showApplicationModal} block outline>View Application</Button>
                </CardFooter>

                <ReduxModalWrapper id={"owner_application_view_modal_" + roommate.id} fullscreen/>
            </Card>
        );
    };

    render() {
        return PolyUtil.propsReady(this.props) ? this.content() : <Loader spin isLoading/>;
    }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
    _displayModal(modalData) {
        return dispatch(displayModal(modalData));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ApplicantCard);



// WEBPACK FOOTER //
// ./src/containers/owner/applications/ApplicantCard.js